import RootAPI from 'api/interfaces/RootAPI';
import * as React from 'react';
const {Provider, Consumer} = React.createContext<RootAPI | null>(null);
export const ApiProvider = Provider;
export const ApiConsumer = Consumer;